// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"10":"6b62bba2d04f9051","691":"52b592f397bd0852"}[chunkId] + ".js";
};